import {isSnsSignUp, setAuthHash} from "../../store.js";

const PhoneAuthInput = (data) => {
    const authCodeWrap = $('.js-auth-code-wrap')
    const authCounterWrap = $('.js-counter-wrap')
    const state = {
        elements: {
            $authInput: authCodeWrap.find('#authCodeInput'),
            $authConfirmButton: SignUpViewChanger.getViewId() === 'userProfileInput' ? $('#userProfileSubmit') : $('#invitationUserFormSubmit'),
            $authCounter: authCounterWrap.find('.js-counter-remaining'),
            $authCounterMessage: authCounterWrap.find('.js-counter-message'),
        },
        isExpired: false,
        userId: undefined,
        phoneNumber: undefined,
        deviceData: {},
        timeLimit: undefined,
        timer: undefined,
    }

    const isTestYopmail = () => !isSnsSignUp() &&  data.userId.includes('test') && data.userId.includes('@yopmail.com');

    function initState(data) {
        state.userId = data.userId
        state.phoneNumber = data.phoneNumber
        state.deviceData = data.deviceData
    }

    function getState() {
        return {
            isExpired: state.isExpired,
            userId: state.userId,
            phoneNumber: state.phoneNumber
        }
    }

    function init() {
        //  SnS 회원 가입은 제외
        if (isTestYopmail()) {
            Mutil.toast("success", "XXtestXX@yopmail.com 아이디는 자동으로 인증됩니다.");
            state.timeLimit = data?.AUTH_TIME_MM ?? '3'
            state.elements.$authCounter.text(`${state.timeLimit}:00`).data('auth-limit-minutes', state.timeLimit)
            startCounter();
            state.elements.$authInput.val('000000');
            state.elements.$authConfirmButton.attr('disabled', false)
            return;
        }

        initState(data)

        const requestData = {
            ... state.deviceData,
            USER_ID: state.userId,
            AUTH_ID: state.phoneNumber,
            AUTH_TYPE: 'H',
        }

        Ajax.executeApi(RestApi.GET.FLOW_AUTH_NO_CHECK_R002, requestData, (data) => {
            state.timeLimit = data?.AUTH_TIME_MM ?? '3'
            state.elements.$authCounter.text(`${state.timeLimit}:00`).data('auth-limit-minutes', state.timeLimit)
            startCounter()
        })
    }

    function startCounter() {
        const timerEndsAt = new Date()
        timerEndsAt.setMinutes(timerEndsAt.getMinutes() + Number(state.timeLimit))

        state.timer = setInterval(() => {
            tickCounter(timerEndsAt)
        }, 1000)

        state.elements.$authCounter.data('timer', state.timer)
        state.elements.$authCounterMessage.text(i18next.t(main.verificationSent))
        state.elements.$authConfirmButton.addClass('disable').attr('disabled', true)
    }

    function tickCounter(endsAt) {
        const now = new Date()
        const duration = endsAt - now
        if (duration < 0) {
            state.isExpired = true
            clearInterval(state.timer)

            state.elements.$authCounterMessage.text(i18next.t(main.alert.verificationExpired))
            state.elements.$authConfirmButton.addClass('disable').attr('disabled', true)
            return
        }

        const MILLISECONDS_UNIT = {
            HOUR: 60 * 60 * 1000,
            MINUTE: 60 * 1000,
            SECOND: 1000
        }
        const leftMinutes = Math.floor((duration % MILLISECONDS_UNIT.HOUR) / MILLISECONDS_UNIT.MINUTE)
        const leftSeconds = Math.floor((duration % MILLISECONDS_UNIT.MINUTE) / MILLISECONDS_UNIT.SECOND)
        state.elements.$authCounter.text(`${leftMinutes}:${leftSeconds.toString().padStart(2, '0')}`)
    }

    function reset() {
        if (typeof state.timer !== 'undefined') {
            clearInterval(state.timer)
            state.elements.$authCounter.text(`${state.timeLimit}:00`)
        }
    }

    async function confirm() {
        if (isTestYopmail()) return true;

        const authCounterLimit = state.elements.$authCounter.data('auth-limit-minutes')
        const authValue = state.elements.$authInput.val()
        if (authValue.length !== 6) {
            // Often.toast("error", i18next.t(main.alert.enterWord, {val: $t(common.confirmVerificationCode)}))
            return false
        }

        const requestData = {
            ... state.deviceData,
            USER_ID: state.userId,
            AUTH_NO: authValue,
            AUTH_TIME_MM: authCounterLimit,
        }

        const result = await Ajax.executeApi(RestApi.GET.FLOW_AUTH_NO_CHECK_R001, requestData)
        if (result.RSLT_CD !== '0000') {
            return false
        }

        // save auth hash
        setAuthHash(Often.null2Void(result.AUTH_HASH))

        return true
    }

    return {
        getState,
        init,
        reset,
        confirm,
    }
}

export default PhoneAuthInput
